import React from 'react';
import PropTypes from 'prop-types';

import { Popup } from '@codex/organisms';


const ProductPopup = ({
  sFullLabel, sProductId, sImageBigUrl, sComplementaryLabel,
  sDescription, onClose
}) => (
  <Popup title={sFullLabel} onClose={onClose} optionalClasses={'dynamicBundleProductPopup'}>
    <section id={`db-prd-${sProductId}`} className={'mediumPopIn dynamicBundleProductPopupContent'}>
      <div className={'in vList'}>
        <article className={'product'}>
          <img
            className={'image'}
            style={{ display: 'block', minHeight: '100%' }}
            src={sImageBigUrl}
            alt={''}
          />
          {sComplementaryLabel !== '' && (
          <div className={'desc'}>
            <ul className={'productDescription tsp'}>
              {sComplementaryLabel.split(', ', 5).map((description) => (
                <li key={description}>{description}</li>
              ))}
            </ul>
          </div>
          )}
        </article>
        <p
          className={'tsp'}
          dangerouslySetInnerHTML={{
            __html: `${sDescription.slice(0, 400)}...`
          }}
        />
      </div>
    </section>
  </Popup>
);

ProductPopup.propTypes = {
  sProductId: PropTypes.string.isRequired,
  sFullLabel: PropTypes.string.isRequired,
  sImageBigUrl: PropTypes.string.isRequired,
  sComplementaryLabel: PropTypes.string,
  sDescription: PropTypes.string.isRequired,
  onClose: PropTypes.func

};

ProductPopup.defaultProps = {
  sComplementaryLabel: '',
  onClose: () => {}
};

export default ProductPopup;
